export const SAVE_SEARCH_BUTTON = "#save-search-button";
export const SAVE_SEARCH_MODAL = "email-retention-modal";

export const EMAIL_RETENTION_POPUP_MOBILE = "#email-retention__popup-mobile";

export const EMAIL_RETENTION_POPUP_MOBILE_FORM = "#email-retention__popup-mobile__form";

export const EMAIL_RETENTION_POPUP_MOBILE_CLOSE_ICON = "#email-retention__popup-mobile__close";

export const EMAIL_RETENTION_POPUP_MOBILE_CLOSE_BUTTON = "#close-retention-popup-mobile";

export const EMAIL_RETENTION_MOBILE_SAVE_ALERT_CTA = "#save-alert-cta";

export const EMAIL_RETENTION_DESKTOP_CLOSE_FLOATING = "#close-email-retention-floating";

export const EMAIL_RETENTION_DESKTOP_FLOATING = "#email-retention-floating";

export const EMAIL_RETENTION_MOBILE_BOTTOM_FORM = "#js-email-retention-form--simplified"
